"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseApiError = parseApiError;
exports.extractApiError = extractApiError;
exports.normalizeResponseError = normalizeResponseError;
const axios_1 = require("axios");
function mapValidationDetailsToFieldErrors(details) {
    if (!details?.length)
        return {};
    return details.reduce((acc, detail) => {
        const field = detail.field?.trim();
        const message = detail.message?.trim();
        if (!field || !message || acc[field])
            return acc;
        acc[field] = message;
        return acc;
    }, {});
}
function parseApiError(error) {
    if ((0, axios_1.isAxiosError)(error)) {
        const data = error.response?.data;
        const fieldErrors = mapValidationDetailsToFieldErrors(data?.error?.details);
        const message = data?.detail ??
            data?.error?.message ??
            data?.message ??
            error.message ??
            "Une erreur est survenue";
        return {
            message,
            code: data?.error?.code,
            fieldErrors,
        };
    }
    return {
        message: "Une erreur est survenue",
        fieldErrors: {},
    };
}
function extractApiError(error) {
    return parseApiError(error).message;
}
/** Mirrors proconnect-web's historical handleResponseError shape/behavior. */
function normalizeResponseError(error) {
    if ((0, axios_1.isAxiosError)(error)) {
        if (error.response) {
            const { status, data } = error.response;
            const message = status === 404
                ? "Service API introuvable. Vérifiez que le backend est démarré."
                : data?.detail || data?.error?.message || data?.message || "Une erreur est survenue";
            return {
                status,
                message,
                details: data?.error?.details || [],
                code: data?.error?.code,
            };
        }
        if (error.request) {
            const isDev = process.env.NODE_ENV !== "production";
            const hint = isDev
                ? " Vérifiez que le serveur API tourne et redémarrez le frontend après modification du .env."
                : " Vérifiez votre connexion internet ou réessayez dans quelques instants.";
            return {
                status: 0,
                message: `Impossible de contacter le serveur.${hint}`,
                details: [],
                isNetworkError: true,
            };
        }
    }
    return {
        status: 0,
        message: error instanceof Error ? error.message : "Erreur inconnue",
        details: [],
    };
}
